/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoChangeFolderVisibilityInput = {
    clientMutationId?: string | null;
    slug: string;
    visibleToRoles: Array<string>;
};
export type FolderRoleVisibilityMutationVariables = {
    input: infoChangeFolderVisibilityInput;
};
export type FolderRoleVisibilityMutationResponse = {
    readonly infoChangeFolderVisibility: {
        readonly clientMutationId: string | null;
    } | null;
};
export type FolderRoleVisibilityMutation = {
    readonly response: FolderRoleVisibilityMutationResponse;
    readonly variables: FolderRoleVisibilityMutationVariables;
};



/*
mutation FolderRoleVisibilityMutation(
  $input: infoChangeFolderVisibilityInput!
) {
  infoChangeFolderVisibility(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoChangeFolderVisibilityPayload",
    "kind": "LinkedField",
    "name": "infoChangeFolderVisibility",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FolderRoleVisibilityMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FolderRoleVisibilityMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aaa906dde6f881b1585f9bf67bd67be3",
    "id": null,
    "metadata": {},
    "name": "FolderRoleVisibilityMutation",
    "operationKind": "mutation",
    "text": "mutation FolderRoleVisibilityMutation(\n  $input: infoChangeFolderVisibilityInput!\n) {\n  infoChangeFolderVisibility(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c850439af84823126a61a174fdaf5690';
export default node;
